// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__aZkZu","active":"Tag_active__IHfg0"};